import { IkeEnvironment, IkeSystem } from '@ikegps/core-api';
import { IkeConfig } from '../..';
import { OfficeBase } from './office.base';

export const OfficeTest2 = new IkeConfig(IkeSystem.OFFICE, IkeEnvironment.TEST2);
const config = OfficeTest2;
config.extend(OfficeBase);

OfficeTest2.set('config.key', 'arn:aws:kms:us-east-1:487538251179:key/af5e8a86-6d0f-4f02-b7fa-080e081ba0c8');
OfficeTest2.set('config.store', 'test2');
OfficeTest2.set('vendor.google.maps', 'AIzaSyA_j7Kpx-R8dPxO29kD6Id0EX724Yj_vZc');

/*
 * todo: We are not using these parameters as these are injected from Dragon-Server
 * when building. They are injected in index.html and is a static file
 */
OfficeTest2.set('vendor.google.analytics', 'UA-73934200-1');
OfficeTest2.set('vendor.google.tagmanager', 'GTM-5BZ5NZJ');
OfficeTest2.set('vendor.google.mapsReleaseChannel', 'weekly');
